import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

import {StackLegacy} from '../../../layout/stack/stack-legacy';
import {Link} from '../../../link/link';

import {PersonCardContent} from './person-card-content';

import styles from './added-contacts.module.css';

export type Contact = {
    id: string;
    name: string;
    htmlUrlPath: string;
    email: string | null | undefined;
    phone: string | null | undefined;
    location: string | null | undefined;
    jobTitle: string | null | undefined;
    position: string | null | undefined;
};

type Props = {
    contacts: Contact[];
};

export function AddedContacts(props: Props) {
    return props.contacts.length ? (
        <div className={styles['added-contacts-list']}>
            <div className={styles['list-header']}>
                People <span>({props.contacts.length})</span>
            </div>
            <StackLegacy spacing={8}>
                {props.contacts.map((contact) => (
                    <Link
                        key={contact.id}
                        as={RoutedLink}
                        newTab={true}
                        preventUnderline={true}
                        to={contact.htmlUrlPath}
                    >
                        <PersonCardContent
                            id={contact.id}
                            name={contact.name}
                            email={contact.email}
                            phone={contact.phone}
                            location={contact.location}
                            jobTitle={contact.jobTitle}
                            position={contact.position}
                        />
                    </Link>
                ))}
            </StackLegacy>
        </div>
    ) : null;
}
